
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoySparEast as ObiBuoySparEastElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-spar-east.js';
 
 
 

 
 export const ObiBuoySparEast = createComponent({
   react: React,
   tagName: 'obi-buoy-spar-east',
   elementClass: ObiBuoySparEastElement,
   events: {
     
   }
  });
 
 